
import React, { useState, ReactNode } from 'react';
import { Icons } from './Icons';

interface AccordionProps {
    title: ReactNode;
    children: ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(true);

    return (
        <div className="bg-white dark:bg-slate-800 rounded-lg shadow-lg overflow-hidden">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex justify-between items-center p-4 text-left gap-4"
            >
                <div className="flex-grow min-w-0">{title}</div>
                <Icons.ChevronDown
                    className={`w-5 h-5 text-gray-500 dark:text-gray-400 transition-transform duration-200 flex-shrink-0 ${
                        isOpen ? 'transform rotate-180' : ''
                    }`}
                />
            </button>
            <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                    isOpen ? 'max-h-[1000px]' : 'max-h-0'
                }`}
            >
                <div className="p-4 border-t border-gray-200 dark:border-slate-700">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Accordion;
